import { render, staticRenderFns } from "./DynamicMenu.vue?vue&type=template&id=38501f2e&scoped=true&"
import script from "./DynamicMenu.vue?vue&type=script&lang=ts&"
export * from "./DynamicMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicMenu.vue?vue&type=style&index=0&id=38501f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38501f2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VIcon,VTreeview})
